import { Provider } from '@angular/core';

import { TwoFactorUseCasesImpl } from '@app/domain/use-cases/ptrab/two-factor/two-factor.use-cases';
import { TWO_FACTOR_USE_CASES } from '@app/domain/use-cases/ptrab/two-factor/two-factor.use-cases.contract';

export const twoFactorUseCasesProvider: Provider = {
  provide: TWO_FACTOR_USE_CASES,
  useClass: TwoFactorUseCasesImpl
};
